/**
 * http://usejsdoc.org/
 */
/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';

import {
    Card, CardImg, CardText, CardBody,
    CardTitle, Breadcrumb, BreadcrumbItem, Button, Modal, ModalHeader, ModalBody, Col, Row, Label
} from 'reactstrap';
import { Control, LocalForm, Errors } from 'react-redux-form';
import jumpersStore from '../../../stores/jumpers-store';
import Select, { components } from 'react-select';
import AsyncSelect from 'react-select/lib/Async';
import loadsStore from '../../../stores/loads-store';
import JmpModal from './customModal';
import { FormGroup, Input, FormText } from 'reactstrap';
import ReactDOM from 'react-dom';



const affOption = [
    { label: 1 }, { label: 2 }, { label: 3 }, { label: 4 }, { label: 5 }, { label: 6 }, { label: 7 }
]


class EditableJumper extends Component {

    constructor(props) {

        super(props);

        this.state = {
            isModalOpen: false,
            jumpType: null,
            load: props.load,
            jumper: props.jumper,
            type: props.type,
            label: props.type,
            jumpId: props.jumpId,
            editMode: props.editMode,
            JumperId: '',
            loadNum: ''
        };
        this.timerId=undefined;
        this.valRef = null;
        this.inputValue = '';
    }

    componentWillMount = () => {
        //console.log('CreateJump componentWillMount');
        document.addEventListener('click', this.handleClickOutside, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    handleClickOutside = event => {
        const domNode = ReactDOM.findDOMNode(this);

        if (!domNode || !domNode.contains(event.target)) {
            this.setState({
                editMode: false
            });
        }
    }

    componentDidMount = () => {
        //console.log('in component did mount editable jumper');
        //console.log(this.valRef);
        if (this.valRef !== null)
            this.valRef.focus();
    }

    componentDidUpdate = () => {
        //console.log('in component did update editable jumper');
        //console.log(this.valRef);
        if (this.valRef !== null)
            this.valRef.focus();
    }


    // handleChange = (selectedOption, loadNum, jumpId, type, label) => {
    //     //console.log("in handle submit for edit jumps");
    //     // this.setState({editMode: !this.state.editMode})
    //     this.setState({
    //         JumperId: selectedOption.value._id,
    //         loadNum: loadNum,
    //         jumpId: jumpId,
    //         type: type,
    //         label: label,
    //         editMode: !this.state.editMode
    //     })
    //     clearTimeout(this.timerId);
    //     this.timerId = setTimeout(this.cancelOrSubmit, 5000);

    // }

    handleAffChange = (selectedOption, loadNum, jumpId, type, label) => {
        //console.log("in handle submit for edit jumps");

        if (type === "aff" && selectedOption !==undefined) {

            if(label === "level")
            {
                var jumpPostBody = { studentPackageId: selectedOption }
            }
            loadsStore.updateAffJump(loadNum, jumpId, jumpPostBody);
            this.setState({editMode: !this.state.editMode});
        }
        //level: parseInt(values.affLevel),
    }

    cancelOrSubmit = () => {
        //console.log(this.timerId)
        var ID = this.state.JumperId;
        var loadNum = this.state.loadNum;
        var jumpId = this.state.jumpId;
        var type = this.state.type;
        var label = this.state.label;

        var jumpPostBody = {};
        //console.log(this.valRef);

         if (type === "aff") {

            if(label === "level")
            {
                var jumpPostBody = { level: ID }
            }
            loadsStore.updateAffJump(loadNum, jumpId, jumpPostBody);
        }
    }


    changeJumper = () => {
        // alert('button click');
        //console.log(this.valRef);
        this.setState({
            editMode: true
        })
    }

    affChangeJumper = () => {
        // alert('button click');
        //console.log(this.valRef);
        this.setState({
            editMode: true
        })
    }

    onSelect(packageId,isCompleted,loadId,affJump){
        this.setState({
          editMode: true,
          packageId: packageId
        }, () =>
          this.handleAffChange(this.state.packageId, this.props.loadNum, this.props.jumpId, this.props.type, 'level', isCompleted, loadId, affJump)
        )
    }


    render() {
        const { isCompleted, loadId, affJump } = this.props;
        var studentPackages = loadsStore.getStudentPackages();
    	var studentPackageMenu = studentPackages.map(pkg =>
    		<a className="dropdown-item" onClick={() => { this.onSelect(pkg._id,isCompleted,loadId,affJump) }} >{pkg.name}</a>
    	)

        return (
          <React.Fragment>
            {
              !this.state.editMode ?
                // <div className="jumpType-button" onClick={() => this.changeJumper(isCompleted)} style={{ padding: '0 1 0 4px' }}> Aff {this.props.level} </div>
                <div className="funjumpType-button" onClick={() => this.changeJumper(isCompleted)}>{affJump.studentPackageName} </div>
                :
                <div className="dropdown-menu" onBlur={()=>{this.setState({editMode: true})}}>
                  <a className="dropdown-item">Select..</a>
                  {studentPackageMenu}
                </div>
            }

          </React.Fragment>
        );
      }

}

export default EditableJumper
